import { 
    Center, Loader
} from '@mantine/core';

export const Loading = () => {

    return (
        <Center style={{ height: '100%'}}>
            <Loader />
        </Center>
    )
}